import React, { useState } from 'react';
import { Optimizations } from 'src/features/MO/components/templates/Optimizations';
import { Page } from '../../components/molecules/Page';
import { MOFilterBar } from '../../features/MO/components/organisms/MOFilterBar';

export const OptimizationPage: React.FC = () => {
  const [isCreateOptimizationOpen, setIsCreateOptimizationOpen] =
    useState(false);

  return (
    <Page
      extraButtons={
        isCreateOptimizationOpen ? null : (
          <MOFilterBar onClick={() => setIsCreateOptimizationOpen(true)} />
        )
      }
      pageTitle={
        isCreateOptimizationOpen
          ? 'Create Optimization'
          : 'Marketing Optimization'
      }
      pageSubtitle="Track your project and goal with full information">
      <Optimizations
        isCreateOptimizationOpen={isCreateOptimizationOpen}
        onClose={() => setIsCreateOptimizationOpen(false)}
      />
    </Page>
  );
};
